import { getToken } from "@/utils/auth";

/* 公共函数 */

// 根据地址栏获取机构ID
let pathname = location.pathname,
  pat = /^\/([^\/]*)?\/?/,
  result = pathname.match(pat);

export let organization = {
  id: result ? result[1] : null,
  tips: '本地开发，地址栏必须带机构id!',
  name: '机构名称'
};

// 以分钟为单位，设置localStorage过期时间，用于存储服务器数据
export let localStorageUtil = {
  set(key, val, expire) {
    let exp = expire ? Date.now() + expire * 1000 * 60 : -1;
    localStorage.setItem(key, JSON.stringify({ value: val, expire: exp }));
    // console.log('set ok', JSON.stringify({value: val, expire: new Date(exp).toLocaleString()}));
  },
  get(key) {
    let data = localStorage.getItem(key);
    // console.log(data);

    if (!data) return null;

    let dataObj = JSON.parse(data);

    if (dataObj.expire == -1) return dataObj.value;

    if (Date.now() >= dataObj.expire) {
      localStorage.removeItem(key);
      return null;
    } else {
      return dataObj.value;
    }
  }
};

// 数字超过一万，以万为单位返回数字
export function getNumbers(num_) {
  if (num_ >= 10000) {
    // 千位下浮动,如：1.21万 -> 1.2万
    // return parseInt(num_/10000*10)/10+'万';
    // 千位上浮动,如：1.21万 -> 1.3万
    return Math.ceil(num_ / 1000) / 10 + 'w'
  } else {
    return num_
  }
}

// 学习进度百分比
export function percentage(total_, viewed_) {
  let percent = total_ === 0 ? 0 : (viewed_ / total_) * 100
  if (percent > 100) { // 容错处理
    percent = 100
  }
  return percent
}

// 文字超出增加...
export function cutStr(value, end) {
  if (value.length > end) {
    return value.substr(0, end) + '...'
  } else {
    return value
  }
}

// 图片地址前缀
export function prefixSrc(value) {
  if (value == 1) {
    return process.env.BASE_GET_IMG_API + "/common/team.png"
  }
  if (value) {
    if (value.indexOf('http') == -1) {
      if (value.substr(0, 1) == "/") {
        return process.env.BASE_GET_IMG_API.concat(value)
      } else {
        return process.env.BASE_GET_IMG_API + '/'.concat(value)
      }

    }
    if (value.indexOf('api/uploads/') != -1 && value.indexOf('http') == -1) {
      return process.env.BASE_API + '/'.concat(value)
    } else {
      return value
    }

  } else {
    return process.env.BASE_GET_IMG_API.concat('/common/student_boy.png')
  }
}


// 节流
export function throttle(fn, delay) {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    if (!timer) {
      timer = setTimeout(function () {
        fn.apply(context, args);
        timer = null;
      }, delay);
    }
  }
}


// 特殊机构处理
export function specialOrg() {
  let orgList = ['aiit-aigc']
  let isSpecial = !orgList.some(e => document.location.href.includes(e))
  return isSpecial;
}

// comfyui登录
export function comfyuiLogin(type, callback) {
  const searchParams = new URLSearchParams(location.search);
  const logintype = searchParams.get('logintype');
  if (logintype == 'comfyui') {
    switch (type) {
      case 1:
        if (getToken()) location.href = `https://comfyui.goyor.com?token=${getToken()}`
        break
      case 2:
        if (!getToken()) callback()
        break
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/common.js